module.exports = __webpack_public_path__ + "static/media/elm-short-logo.adf09148.png";